import * as actions from './eStoreProduct/actions'
import * as mutations from './eStoreProduct/mutations'
import * as getters from './eStoreProduct/getters'

import { dataProps } from './eStoreProduct/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, 
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, 
        search_term: '', 
        search_term_array: []
    },    
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreProduct.js